/** @jsxImportSource @emotion/react */
import { useQuery } from '@apollo/client'
import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'

import {
  findAllAiTestTrainingDataHistory,
  findAllAiTestTrainingDataHistoryVariables,
} from '__generatedTypes__/findAllAiTestTrainingDataHistory'
import { OrderDirection } from '__generatedTypes__/globalTypes'
import { PageLoader } from 'components/PageLoader'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { FIND_ALL_AI_TEST_TRAINING_DATA_HISTORY } from 'queries/trainingAIModel'
import { TrainingHistory } from './TrainingHistory'
import * as classes from './styles'

export const TrainAIModel = () => {
  const { data, loading } = useQuery<findAllAiTestTrainingDataHistory, findAllAiTestTrainingDataHistoryVariables>(
    FIND_ALL_AI_TEST_TRAINING_DATA_HISTORY,
    {
      variables: {
        query: {
          order: { createdAt: OrderDirection.DESC },
          take: TAKE_ALL_ITEMS_COUNT,
        },
      },
      fetchPolicy: 'cache-and-network',
    }
  )

  const jobs = data?.findAllAiTestTrainingDataHistory.items ?? []

  if (loading && !jobs.length) {
    return <PageLoader />
  }

  return (
    <section css={classes.wrapper}>
      <Typography css={classes.header} variant="title3">
        Train A.I. model
      </Typography>

      <div css={classes.content}>
        <Button color="blue" size="small" fullWidth disabled>
          Train A.I.
        </Button>

        <TrainingHistory jobs={jobs} />
      </div>
    </section>
  )
}
